module.exports = {
  bind: function (el, binding, vnode) {
    var options = {
      command: binding.value.command || 'send',
      category: binding.value.category || 'default_category',
      action: binding.value.action || 'click',
      label: binding.value.label || 'null'
    };

    $(el).on(
      options.action,
      function () {
        ga(options.command, 'event', options.category, options.label, options.action);
      }.bind(this)
    );
  }
};
